import React, { useEffect, useState } from "react";
import "./styles/PacientesDash.css"; // (Opcional) caso queira estilizar separado

const PacientesDash = () => {
  const [patientData, setPatientData] = useState(null); // Armazena os dados do paciente
  const [loading, setLoading] = useState(false);        // Controla o spinner de carregamento
  const [error, setError] = useState(null);             // Armazena erros (se ocorrerem)

  useEffect(() => {
    // Função para buscar dados do paciente
    const fetchPatientData = async () => {
      const authToken = localStorage.getItem("authToken");
      const patientId = localStorage.getItem("patientId");

      if (!authToken || !patientId) {
        setError("Token de autenticação ou ID do paciente não encontrado.");
        return;
      }

      setLoading(true);
      try {
        // Faz a requisição GET ao endpoint específico do paciente
        const response = await fetch(
          `https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/paciente/${patientId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            `Erro ao buscar dados do paciente. Status: ${response.status}`
          );
        }

        const data = await response.json();
        console.log("Dados do usuário:", data);

        // Salva no localStorage para outras telas que precisem
        localStorage.setItem("patientData", JSON.stringify(data));
        // Armazena no estado do componente
        setPatientData(data);
      } catch (err) {
        console.error("Erro ao buscar dados do paciente:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    // Chama a função ao montar o componente
    fetchPatientData();
  }, []);

  // Enquanto estiver carregando, exibe um spinner ou mensagem
  if (loading) {
    return <div className="spinner"></div>;
  }

  // Se ocorreu algum erro, exibe a mensagem
  if (error) {
    return <p style={{ color: "red" }}>Erro: {error}</p>;
  }

  // Se ainda não carregou dados e não há erro, retorna nulo ou um "vazio"
  if (!patientData) {
    return null;
  }

  // Renderiza as informações do paciente
  return (
    <div className="pacientes-dash">
      <div className="welcome-div">
        <h1>Bem-vindo, {patientData.Name}</h1>
        <h3>Que nenhuma pessoa morra por falta de saúde!</h3>
      </div>
      <div className="info-div">
        <p>Email: {patientData.email}</p>
        <p>Quantidade de consultas: {patientData.qtd_consultas}</p>
        <p>
          Valor Total Cashback: R${" "}
          {patientData.cashback?.toFixed(2).replace(".", ",")}
        </p>
      </div>
    </div>
  );
};

export default PacientesDash;
